var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step-page" }, [
    _vm.content
      ? _c(
          "div",
          [
            _c("div", { staticClass: "step-block" }, [
              _c(
                "div",
                { staticClass: "title-container" },
                [
                  _c("Logo", { staticClass: "item" }),
                  _c("h4", { staticClass: "item title" }, [
                    _vm._v(" " + _vm._s(_vm.title) + " "),
                  ]),
                  _c("div", { staticClass: "item" }),
                ],
                1
              ),
            ]),
            _c("ValidationObserver", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ handleSubmit }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "step-content",
                            staticStyle: { background: "transparent" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "inner-card",
                                staticStyle: { color: "#fff" },
                              },
                              [
                                _c("div", {
                                  domProps: { innerHTML: _vm._s(_vm.content) },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "check-wrap" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: {
                                          required: { allowFalse: false },
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.check,
                                                        expression: "check",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.check
                                                      )
                                                        ? _vm._i(
                                                            _vm.check,
                                                            null
                                                          ) > -1
                                                        : _vm.check,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a = _vm.check,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.check =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.check = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.check = $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BUTTON.RESUME_AGREE"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                errors[0]
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "text-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary mt-4",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return handleSubmit(_vm.agree)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                2153673942
              ),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }